@if ((scientificRigourPlayers$ | async); as scientificRigourPlayers) {
  <app-player-list name="Coca-cola Leaderboard" [columns]="scientificRigourColumns" [data]="scientificRigourPlayers"
    [totalPlayers]="scientificRigourPlayers.length" [showDownloadButton]="true"
    [worksheetColumns]="scientificRigourWorksheetColumns">
  </app-player-list>
}
